export { default } from './Skeleton';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Skeleton/index.js
// module id = 374
// module chunks = 0